import { useEffect, useState } from "react";
import { Printer } from "lucide-react";
import { useAuth } from "../lib/auth";
import { api, errMsg } from "../lib/api";
import { Badge, Btn, Card, Field, Input, Select, PageHeader, Th, Td, Empty } from "../components/common";

export default function Roster() {
  const { user, meta, isGlobal } = useAuth();
  const [gkk, setGkk] = useState(isGlobal ? "" : user.gkk_id);
  const [date, setDate] = useState("");
  const [d, setD] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => {
    if (!gkk) return;
    setErr("");
    api.get("/gkk-roster", { params: { gkk_id: gkk, date: date || undefined } }).then((r) => setD(r.data)).catch((e) => { setD(null); setErr(errMsg(e)); });
  }, [gkk, date]);
  const gkks = [...(meta?.gkks || [])].sort((a, b) => (a.code || "").localeCompare(b.code || "", undefined, { numeric: true }));
  return (
    <div>
      <PageHeader title="Unit Treasurers & Wednesday Reporting" subtitle="Printable list for the GKK President. Contact numbers appear only if the parish entered them." />
      <Card className="mb-6 no-print">
        <div className="grid sm:grid-cols-[1fr_220px_auto] gap-4 items-end">
          <Field label="GKK">
            <Select data-testid="roster-gkk-select" value={gkk || ""} onChange={(e) => setGkk(e.target.value)} disabled={!isGlobal}>
              <option value="">— Choose GKK —</option>
              {gkks.map((g) => <option key={g.id} value={g.id}>{g.code} · {g.name}</option>)}
            </Select>
          </Field>
          <Field label="Up to Wednesday"><Input data-testid="roster-date-input" type="date" value={date} onChange={(e) => setDate(e.target.value)} /></Field>
          <Btn data-testid="roster-print-button" onClick={() => window.print()} disabled={!d}><Printer className="h-5 w-5" /> Print</Btn>
        </div>
      </Card>
      {err && <p className="text-[#B91C1C] mb-4">{err}</p>}
      {!d && !err && <Empty>Choose a GKK to see its list.</Empty>}
      {d && (
        <Card className="p-5 sm:p-8" data-testid="roster-sheet">
          <div className="text-center">
            <div className="font-serif text-lg font-black text-[#5C4033]">SAINT FRANCIS OF ASSISI PARISH</div>
            <div className="text-sm">Barangay Mabuhay, General Santos City · Diocese of Marbel</div>
            <div className="font-bold mt-2 tracking-widest text-sm">UNIT TREASURERS & WEDNESDAY REPORTING</div>
          </div>
          <div className="mt-4 text-sm grid sm:grid-cols-2 gap-1">
            <div>GKK: <b data-testid="roster-gkk-name">{d.gkk.name}</b> ({d.gkk.code})</div><div>Zone: <b>{d.gkk.zone}</b></div>
            <div className="sm:col-span-2">Address: {d.gkk.address}</div>
          </div>
          <div className="tbl-wrap mt-4">
            <table className="tbl text-sm" data-testid="roster-table">
              <thead><tr><Th>Unit</Th><Th>Leader</Th><Th>Treasurer</Th><Th>Contact</Th><Th>Sign-in</Th>{d.wednesdays.map((w) => <Th key={w}>Wed {w.slice(5)}</Th>)}</tr></thead>
              <tbody>
                <tr className="bg-[#FAF7F2]"><Td><b>GKK-level</b></Td><Td>—</Td><Td>—</Td><Td>—</Td><Td>—</Td>{d.gkk_level.map((w) => <Td key={w.date}><Badge s={w.status} /></Td>)}</tr>
                {d.units.map((u) => (
                  <tr key={u.unit_id} data-testid={`roster-row-${u.code}`}>
                    <Td><b>{u.name}</b><div className="text-xs font-mono text-[#6E6259]">{u.code}</div></Td>
                    <Td>{u.leader || "—"}</Td><Td>{u.treasurer || <span className="text-[#B91C1C]">Not yet named</span>}</Td><Td>{u.contact || "—"}</Td>
                    <Td>{u.has_sign_in ? "Yes" : "No"}</Td>
                    {u.weeks.map((w) => <Td key={w.date}><Badge s={w.status} /></Td>)}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <p className="text-xs text-[#6E6259] mt-3">Statuses: Reported · No Collection (zero report) · Service Canceled · Not Yet Reported. Generated {d.generated_at.replace("T", " ").slice(0, 16)} PST. Confidential — for GKK officers only.</p>
        </Card>
      )}
    </div>
  );
}
